import commentJsonParser from 'comment-json';
import jsonxml from 'jsontoxml';
import { isNil } from 'lodash';

export default {
  parseJson,
  stringifyJson,
  queryStringToJSON,
  parseToFormat,
  isJSON,
};

// Poor man's Json Validation
function parseJson(json, commentsAllowed) {
  if (isNil(json)) return json;
  try {
    var theJson;
    if (commentsAllowed) {
      theJson = commentJsonParser.parse(json);
    } else {
      theJson = commentJsonParser.parse(json, null, true);
    }
    return theJson;
  } catch (e) {
    console.log('JSON parsing failed');
    return null;
  }
}

function stringifyJson(json, prettifySpace = '\t') {
  try {
    let theJson = commentJsonParser.stringify(json, null, prettifySpace);
    return theJson;
  } catch (e) {
    console.log(e);
    return null;
  }
}

function queryStringToJSON(queryString) {
  var pairs = queryString.split('&');

  var result = {};
  pairs.forEach(function (pair) {
    pair = pair.split('=');
    result[pair[0]] = decodeURIComponent(pair[1] || '');
  });

  return commentJsonParser.parse(commentJsonParser.stringify(result));
}

function parseToFormat(json, format) {
  let text = '';
  try {
    switch (format) {
      case 'application/json':
        text = stringifyJson(json);
        break;
      case 'application/xml':
        text = jsonxml(json, { prettyPrint: true });
        break;
      default:
        text = stringifyJson(json);
    }
  } catch (ex) {
    text = '';
  }
  return text;
}

function isJSON(str) {
  try {
    return JSON.parse(str) && !!str;
  } catch (e) {
    return false;
  }
}
